<template>
  <form @submit.prevent="handleSubmit">
    <div class="mb-2">
      <v-input
        required
        :placeholder="$t('components.auth.setPasswordForm.placeholder')"
        v-model="password"
        type="password"
        name="password"
        autofocus
      ></v-input>
    </div>
    <div class="mb-2">
      <v-input
        required
        :placeholder="
          $t('components.auth.setPasswordForm.confirmationPlaceholder')
        "
        v-model="passwordConfirmation"
        type="password"
        name="passwordConfirmation"
        autofocus
      ></v-input>
    </div>
    <v-button :is-loading="isLoading" block class="mb-2" type="submit">
      {{ $t("components.auth.setPasswordForm.cta") }}
    </v-button>
  </form>
</template>

<script>
import vInput from "@/components/forms/vInput"

export default {
  components: {
    vInput
  },

  data() {
    return {
      password: "",
      passwordConfirmation: "",
      isLoading: false
    }
  },

  methods: {
    handleSubmit() {
      this.isLoading = true

      if (this.password !== this.passwordConfirmation) {
        this.isLoading = false
        return this.$notify(
          this.$t("components.auth.setPasswordForm.passwordNotMatch")
        )
      } else if (this.password.length < 6) {
        this.isLoading = false
        this.$notify(
          this.$t("components.auth.setPasswordForm.passwordTooShort")
        )
      } else {
        this.$emit("submit", {
          password: this.password,
          passwordConfirmation: this.passwordConfirmation
        })
        setTimeout(() => {
          this.isLoading = false
        }, 1500)
      }
    }
  }
}
</script>
